import React, { Component } from 'react';
import '../assets/custom.css';
import './LoginFields.css';
import { withRouter, Redirect } from 'react-router-dom';
import {Modal} from "react-bootstrap";
import REST from '../Shared/REST';
import {updateTeacher,updateSchoolAdmin} from "../TeachersComponent/actions";
import {updateFirstLogin, updateStudentUser} from "../StudentsComponent/actions";
import {connect} from "react-redux";
import DialogBox from "../Shared/DialogBox";
import closeModalIcon from "../assets/images/ico-close.png";
import pinIcon from "../assets/images/pin.png";
import TRACKING from "../Shared/DataTrackingPoints";

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30%'
    }
};

// Modal.setAppElement('body');

class LoginFields extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            rememberMe: this.props.rememberMe,
            isModalOpen: false,
            resetEmail: '',
            resetType: "username",
            email: "",
            submitting: false,
            emailGUID:null,
            newpassword:"",
            confirmpassword:"",
            usernameEmailError: '',
            passwordEmailError: '',
            errorEmailNoteUsername: '',
            errorEmailNotePassword: '',
            modalDialog:false,
            responseContent:'',
            infoWarning: '',
            checked:false,
            analytics: {
                type: null,
                metadata: null,
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSelf = this.closeModalSelf.bind(this);
        this.resetSubmit = this.resetSubmit.bind(this);
        this.handleResetEmailChange = this.handleResetEmailChange.bind(this);
        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
        this.changePasswordSubmit = this.changePasswordSubmit.bind(this);
        this.closePasswordModal = this.closePasswordModal.bind(this);
        this.handleInfoWindow = this.handleInfoWindow.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    async componentDidMount(){
        await this.setState({
            emailGUID:localStorage.getItem('emailGUID')
        });
        if(localStorage.getItem('checked')) {
            await this.setState({
                username: localStorage.getItem('usr'),
                password: localStorage.getItem('psw'),
                checked: true
            })
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    async handleChecked(){
        await this.setState({
            checked: this.state.checked ? false : true},
            () => {
              if(this.state.checked == true){
                  localStorage.setItem('usr',this.state.username);
                  localStorage.setItem('psw',this.state.password);
                  localStorage.setItem('checked', this.state.checked);
              } else {
                  localStorage.removeItem('usr');
                  localStorage.removeItem('psw');
                  localStorage.removeItem('checked');
              }
            }
        );
    }

    handleInfoWindow(){
        this.setState({
            modalDialog:true,
            infoWarning: 'Important. This is a test version of the new software. Please help us to improve the software. <br/>Use the <div id="bugReport" ></div> button to report errors or to recommend changes.',
            responseContent: ''
        })
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal() {
        this.setState({ isModalOpen: false, email:"" });
    }

    closeModalSelf(e) {
        e.stopPropagation();
        this.setState({ showModal: false});
    }

    handleChange(event) {
        this.setState({ username: event.target.value, password: this.state.password });
    }

    handleResetEmailChange(event) {
        this.setState({email:event.target.value.toLowerCase()});
    }

    handlePassword(event) {
        this.setState({ username: this.state.username, password: event.target.value });
    }

    async handleSubmit(event) {
        await this.setState({
            username: this.state.username.toString().replace(/\D/g,'')
        })
        if (!this.state.username) {
            this.setState({
                modalDialog: true,
                responseContent:'User number is required!',
                infoWarning: null

            });
            return;
        }
        if (!this.state.password) {
            this.setState({
                modalDialog: true,
                responseContent:'Password is required!',
                infoWarning: null

            });
            return;
        }
        this.tryLogin();
    }

    async handleReset(type) {
        await this.setState({ isModalOpen: true, resetType:type });
    }

    validate() {
        let valid = true;
        if(this.state.resetType === "username"){
            if(this.state.email === null || this.state.email.length === 0){
                valid = false;
                this.setState({usernameEmailError: 'validationRed' });
            }
            else{
                this.setState({usernameEmailError: '' });
            }
        }
        else{
           if(this.state.email === null || this.state.email.length === 0){
                valid = false;
                this.setState({passwordEmailError: 'validationRed' });
            }
            else{
                this.setState({passwordEmailError: '' });
            }

        }
        return valid;
        //TODO: check email for regex
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    resetSubmit(type) {
        this.setState({
           submitting:true
        });
        if(type==="password") {
            if(this.validate()) {
                this.setState({errorEmailNotePassword: '' });
                    REST.resetPassword({email: this.state.email}).then((res) => {
                        this.setState({errorEmailNotePassword: '', passwordEmailError: '',modalDialog: true, responseContent: 'An email with the password has been sent to the email provided.',infoWarning: null});
                        this.closeModal();
                        setTimeout(()=>{this.setState({modalDialog:false})},3500);
                        this.setState({
                            submitting: false
                        });
                    }).catch((e) => {
                        this.setState({
                            submitting: false,
                            errorEmailNotePassword: 'Invalid email provided.'
                        });
                    });
            } else {
                this.setState({
                    submitting: false
                });
                this.setState({errorEmailNotePassword: 'Email address format is invalid' });
            }
        }else{
            if(this.validate()) {
                this.setState({errorEmailNoteUsername: '' });
                    REST.resetUsername({email: this.state.email}).then((res) => {
                        this.setState({errorEmailNoteUsername: '', usernameEmailError: '',modalDialog: true, responseContent:'An email with the username has been sent to the email provided.',infoWarning: null});
                        this.closeModal();
                        setTimeout(()=>{this.setState({modalDialog:false})},3500);
                        this.setState({
                            submitting: false
                        });
                    }).catch((e) => {
                        this.setState({
                            submitting: false,
                            errorEmailNoteUsername: 'Invalid email provided.'
                        });
                    });
            }
            else{
                this.setState({
                    submitting: false
                });
                this.setState({errorEmailNoteUsername: 'Email address format is invalid' });
            }
        }
    }


    async closePasswordModal() {
        await this.setState({
            emailGUID:null,
            confirmpassword:""
        });
        await localStorage.removeItem('emailGUID');
        await localStorage.clear();
    }

    handleNewPasswordChange(event) {
        this.setState({newpassword:event.target.value});
    }

    handleConfirmPasswordChange(event) {
        this.setState({confirmpassword:event.target.value});
    }

    async changePasswordSubmit() {

        if(this.state.newpassword.length>0 && this.state.newpassword===this.state.confirmpassword) {
            await this.setState({
                submitting: true
            });
            await REST.changePassword({
                emailGUID: this.state.emailGUID,
                password: this.state.newpassword
            }).then(async(res) => {
                await this.closePasswordModal();
                await this.setState({
                    submitting: false,
                    username: res.body.id.toString(),
                    password: this.state.newpassword,
                    modalDialog: true,
                    responseContent:'Password Changed Successfully.',
                    infoWarning: null

                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.tryLogin();},3500);
            }).catch((e) => {
                this.setState({
                    submitting: false,
                    modalDialog: true,
                    responseContent:'Invalid data provided.',
                    infoWarning: null
                });
                this.closePasswordModal();
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }else {
            this.setState({
                modalDialog: true,
                responseContent:'Please fill out all fields correctly.',
                infoWarning: null

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        }
    }

    tryLogin() {
        REST.login(this.state.username, this.state.password).then((result) => {
            if (result.success) {
                localStorage.setItem('token', result.body.token);
                if(result.body.user.role === "teacher") {
                         this.setState({
                            analytics:{
                                type:TRACKING.TEACHER_LOGIN,
                                metadata:{
                                    userId: result.body.user.id,
                                    platform: navigator.platform,
                                    userAgent: navigator.userAgent
                                }
                            }
                        },
                        ()=> this.handleAnalytics());
                    this.props.updateTeacher(result.body.user);
                    this.props.updateSchoolAdmin(null);
                }else if(result.body.user.role === "student"){
                    this.props.updateStudentUser(result.body.user);
                    this.setState({
                            analytics:{
                                type:TRACKING.STUDENT_LOGIN,
                                metadata:{
                                    userId: result.body.user.id,
                                    platform: navigator.platform,
                                    userAgent: navigator.userAgent
                                }
                            }
                        },
                        ()=> this.handleAnalytics());
                    this.props.updateFirstLogin(true);
                }else if(result.body.user.role === "school-admin"){
                    this.props.updateTeacher(null);
                    this.props.updateSchoolAdmin(result.body.user);
                    this.setState({
                            analytics:{
                                type:TRACKING.SCHOOL_ADMIN_LOGIN,
                                metadata:{
                                    userId: result.body.user.id,
                                    platform: navigator.platform,
                                    userAgent: navigator.userAgent
                                }
                            }
                        },
                        ()=> this.handleAnalytics());
                }else if(result.body.user.role === "parent"){
                    this.setState({
                            analytics:{
                                type:TRACKING.PARENT_LOGIN,
                                metadata:{
                                    userId: result.body.user.id,
                                    platform: navigator.platform,
                                    userAgent: navigator.userAgent
                                }
                            }
                        },
                        ()=> this.handleAnalytics());
                }
                this.props.callbackFromParent(result.body.user);
                this.props.history.push('/' + result.body.user.role);
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent: result.msg,
                    infoWarning: null

                });
                setTimeout(()=>{this.setState({modalDialog:false})},2500);
            }
        }, (error) => {
            console.log('Error', error.msg);
            this.setState({
                modalDialog: true,
                responseContent: error,
                infoWarning: null

            });
            setTimeout(()=>{this.setState({modalDialog:false})},2500);
        });
    }

    handleLoginEnterKeyPress = (event) => {
        if(event.key == 'Enter'){
            this.handleSubmit();
        }
    }

    handleResetEnterKeyPress = (event) => {
        if(event.key == 'Enter'){
            this.resetSubmit(this.state.resetType);
        }
    }

    render() {
        if (this.user) {
            return <Redirect to={{
                pathname: "/", state: {
                    from: this.props.location
                }
            }} />
        }

        return (
            <div>
                <div id="pinIcon">
                    <img src={pinIcon} alt="" border="0" />
                </div>
                <div className="formLogin">
                    <h3>Log in to AvenuePM</h3>
                    <div className="input-title">User Number</div>
                    <input type="text" value={this.state.username} className="form-control"  onChange={this.handleChange} placeholder="User Number" onKeyPress={this.handleLoginEnterKeyPress}  required autoFocus />
                    <div className="input-title">Password</div>
                    <input type="password" value={this.state.password} className="form-control"  onChange={this.handlePassword} placeholder="Password" onKeyPress={this.handleLoginEnterKeyPress}  required />
                    <div className="login-extra">
                        <div>
                            <a onClick={()=>this.handleReset("username")} className="login-other">Forgot User Number</a>
                        </div>
                        <div >
                            <a onClick={()=>this.handleReset("password")} className="login-other">Forgot Password</a>
                        </div>
                    </div>
                    <div className="checkbox" style={{marginTop:30}}>
                        <label>
                            <input type="checkbox" name="rememberMe" defaultChecked={localStorage.getItem('checked')} onChange={this.handleChecked} />Remember Me</label>
                    </div>
                    <div className={"row"}>
                        <div className={"col-md-10 col-xs-9"}>
                            <div className={"row"}>
                             <button onClick={this.handleSubmit} name="Login" className="btn btn-primary loginButton" >Log In</button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="createAccountLabel" className="fl">New here?</div>
                        <a id="createAccountLink" href="/request-account" className="fr">Create a new account</a>
                    </div>
                </div>
                <Modal id={"getusernamepassword"} show={this.state.isModalOpen} >
                    <div className="modal-content">
                        <div className={"row modal-body"} style={{textAlign:'left'}}>
                            <span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:30,marginTop:25,float:'right'}} src={closeModalIcon} /></span>
                    <h2>{this.state.resetType === "username" ? "GET USER NUMBER" : "RESET PASSWORD" }</h2>
                    <hr />
                        <div style={{color:'red'}}>{this.state.resetType==="password"? this.state.errorEmailNotePassword : this.state.errorEmailNoteUsername}</div>
                        <input style={{marginBottom:25}} id={this.state.resetType==="password"?"inputResetPassword":"inputGetUsername"} required={true} value={this.state.value} className={this.state.resetType==="password"? "form-control " + this.state.passwordEmailError : "form-control " +this.state.usernameEmailError} onChange={this.handleResetEmailChange} placeholder={this.state.resetType==="password"?"Email":"Email"} onKeyPress={this.handleResetEnterKeyPress} />

                    {this.state.submitting ?
                        "Please Wait...":
                        <a onClick={()=>this.resetSubmit(this.state.resetType)} name="Submit" className="handBtn"><span>Submit</span></a>
                    }
                        </div>
                    </div>
                </Modal>
                <DialogBox notificationModal  modalOpen={this.state.modalDialog} infoWarning={this.state.infoWarning} sectionContent={this.state.responseContent} htmlSection closeClick={(active)=>{this.setState({modalDialog: active});}} />

                <Modal show={this.state.emailGUID!=null} style={customStyle}>
                <div className="modal-content">
                    <div className={"row modal-body"} style={{textAlign:'left'}}>
                    <h2>Change Password</h2>
                    <hr />
                    <div className="section">
                        <input type={"password"} required={true} className="form-control" onChange={this.handleNewPasswordChange} placeholder={"Password"} />
                        <br/>
                        <input type={"password"} required={true} className="form-control" onChange={this.handleConfirmPasswordChange} placeholder={"Confirm Password"} />
                        {this.state.newpassword.length===0 ? <div><br/><span>The password must not be empty..</span></div> : null}
                        {this.state.confirmpassword !== this.state.newpassword ? <div><br/><span>Passwords must match</span></div> : null}
                    </div>
                    {this.state.submitting ?
                        "Please Wait...":
                        <a onClick={()=>this.changePasswordSubmit()} type={"submit"} name="Submit" className="handBtn"><span>Submit</span></a>
                    }
                        <a onClick={this.closePasswordModal} style={{marginLeft:5}} name="Close" className="handBtn"><span>Close</span></a>
                    </div>
                </div>
                </Modal>
            </div>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateFirstLogin: async(results) => await dispatch(updateFirstLogin(results)),
        updateTeacher: async(data) => await dispatch(updateTeacher(data)),
        updateStudentUser: async(data) => await dispatch(updateStudentUser(data)),
        updateSchoolAdmin: async(data) => await dispatch(updateSchoolAdmin(data))
    };
};

const mapStateToProps = state => ({
    firstLogin:state.studentReducer.firstLogin,
    teacher: state.teacherReducer.teacher,
    studentUser: state.studentReducer.studentUser,
    schoolAdmin: state.teacherReducer.schoolAdmin
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(LoginFields));



// WEBPACK FOOTER //
// ./src/LoginFields/LoginFields.js